const LIVE_SNAPSHOT_MIN_BUILD = 179139464;
const CHAT_FILTER_TABS_MIN_BUILD = 179215030;
const TAB_BAR_MIN_BUILD = 179215030;
const CHAT_FILTER_TABS = [
    { id: 'all', name: '전체 채팅', hideable: false },
    { id: 'direct', name: '1:1', hideable: true },
    { id: 'community', name: '커뮤니티', hideable: true },
    { id: 'unread', name: '안읽음', hideable: true },
];
function chatFilterTabSettings() {
    return CHAT_FILTER_TABS.flatMap(({ id, name, hideable }, index) => {
        const order = {
            key: `chat.filter.${id}.order`,
            screen: 'chat',
            group: '필터 탭',
            label: `${name} 탭 순서`,
            help: '숫자가 작을수록 왼쪽에 보인다. 같은 숫자면 기본 순서(전체 채팅 → 1:1 → 커뮤니티 → 안읽음)',
            type: 'integer',
            defaultValue: index + 1,
            min: 1,
            max: 99,
            unit: '번째',
            minBuildNumber: CHAT_FILTER_TABS_MIN_BUILD,
        };
        if (!hideable)
            return [order];
        return [
            order,
            {
                key: `chat.filter.${id}.visible`,
                screen: 'chat',
                group: '필터 탭',
                label: `${name} 탭 표시`,
                help: '끄면 채팅 목록에서 이 탭이 사라진다. 기본 필터가 숨긴 탭이면 전체 채팅으로 연다',
                type: 'boolean',
                defaultValue: true,
                minBuildNumber: CHAT_FILTER_TABS_MIN_BUILD,
            },
        ];
    });
}
const LOUNGE_HUB_TABS = [
    { id: 'dealerChat', name: '딜러채팅방' },
    { id: 'liveSnapshot', name: '힛 갤러리' },
    { id: 'lounge', name: '라운지' },
];
function loungeHubTabOrderSettings() {
    return LOUNGE_HUB_TABS.map(({ id, name }, index) => ({
        key: `lounge.tab.${id}.order`,
        screen: 'lounge',
        group: '상단 탭',
        label: `${name} 탭 순서`,
        help: '숫자가 작을수록 왼쪽에 보이고, 맨 왼쪽 탭이 라운지 탭을 눌렀을 때 처음 열린다(홈 더보기는 그 탭으로 바로 연다). 같은 숫자면 기본 순서(딜러채팅방 → 힛 갤러리 → 라운지). 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'integer',
        defaultValue: index + 1,
        min: 1,
        max: 99,
        unit: '번째',
        minBuildNumber: null,
    }));
}
const TAB_BAR_TABS = [
    { id: 'home', name: '홈' },
    { id: 'market', name: '마켓' },
    { id: 'create', name: '추가(+)' },
    { id: 'lounge', name: '라운지' },
    { id: 'me', name: '마이페이지' },
];
function tabBarIconSettings() {
    return TAB_BAR_TABS.map(({ id, name }) => ({
        key: `common.tabBar.${id}.iconUrl`,
        screen: 'common',
        group: '하단 탭',
        label: `${name} 아이콘`,
        help: '비워 두면 앱 기본 아이콘. 올린 이미지는 모양만 쓰고 색은 앱이 선택·미선택 색으로 칠하므로 배경이 투명한 PNG·WEBP(정사각형, 96×96 이상 권장)를 올린다',
        type: 'image',
        defaultValue: '',
        minBuildNumber: TAB_BAR_MIN_BUILD,
    }));
}
const HOME_SECTION_ORDER_ITEMS = [
    { value: 'currentLive', label: '진행중 라이브' },
    { value: 'scheduledLive', label: '예정 라이브' },
    { value: 'boltbMarket', label: '볼트비 마켓' },
    { value: 'market', label: '마켓' },
    { value: 'notices', label: '공지사항' },
    { value: 'popularLounge', label: '라운지 인기글' },
    { value: 'community', label: '커뮤니티' },
];
function visible(key, screen, label, help) {
    const definition = {
        key,
        screen,
        label,
        type: 'boolean',
        defaultValue: true,
        minBuildNumber: null,
    };
    return help === undefined ? definition : { ...definition, help };
}
function inGroup(group, definitions) {
    return definitions.map((definition) => ({ ...definition, group }));
}
const IMAGE_FIT_OPTIONS = [
    { value: 'contain', label: '여백(잘리지 않음)' },
    { value: 'cover', label: '채움(넘치는 부분 잘림)' },
];
function imageFit(key, label, defaultValue) {
    return {
        key,
        screen: 'home',
        label,
        help: '이미지 비율이 칸과 다를 때: 여백 = 전체가 보이고 남는 곳이 빈다, 채움 = 칸을 채우고 넘치는 부분이 잘린다',
        type: 'enum',
        defaultValue,
        options: IMAGE_FIT_OPTIONS,
        minBuildNumber: null,
    };
}
function homeSectionOrder(id, name, order) {
    return {
        key: `home.${id}.order`,
        screen: 'home',
        label: `${name} 표시 순서`,
        help: '숫자가 작을수록 위에 보인다. 같은 숫자면 기본 순서(진행중 라이브 → 예정 라이브 → 볼트비 마켓 → 마켓 → 공지사항 → 힛 갤러리 → 라운지 인기글 → 딜러채팅방 → 커뮤니티). 배너·카테고리는 항상 위, 사업자 정보는 항상 아래',
        type: 'integer',
        defaultValue: order,
        min: 1,
        max: 99,
        unit: '번째',
        minBuildNumber: null,
    };
}
function homeSectionMarginTop(id, name, defaultPx) {
    const original = defaultPx === 0
        ? '기본값 0은 기존 그대로(여백 없음)'
        : `기본값 ${defaultPx}은 기존 여백 그대로(앱 ${(defaultPx * 14) / 16}dp·웹 ${defaultPx}px)`;
    return {
        key: `home.${id}.marginTop`,
        screen: 'home',
        label: `${name} 위 여백`,
        help: `섹션 간격에 더해지는 이 영역만의 위 여백. ${original}, 다른 값은 그 크기`,
        type: 'integer',
        defaultValue: defaultPx,
        min: 0,
        max: 64,
        unit: 'px',
        minBuildNumber: null,
    };
}
const EMPTY_MODE_OPTIONS = [
    { value: 'full', label: '안내 문구(큰 여백)' },
    { value: 'compact', label: '안내 문구 한 줄' },
    { value: 'hidden', label: '영역 숨김' },
];
function homeSectionEmptyMode(id, name, defaultValue, extraHelp) {
    const help = '영역 숨김 = 제목까지 보이지 않는다(선택한 카테고리에 내용이 생기면 다시 보인다). 안내 문구 한 줄 = 낮은 높이, 안내 문구(큰 여백) = 아이콘과 넓은 여백';
    return {
        key: `home.${id}.emptyMode`,
        screen: 'home',
        label: `${name} 내용이 없을 때`,
        help: extraHelp === undefined ? help : `${help}. ${extraHelp}`,
        type: 'enum',
        defaultValue,
        options: EMPTY_MODE_OPTIONS,
        minBuildNumber: null,
    };
}
export const CARD_IMAGE_RATIO_OPTIONS = [
    { value: '1:1', label: '1:1(정사각)' },
    { value: '3:4', label: '3:4(세로로 긴)' },
    { value: '9:16', label: '9:16(세로로 긴)' },
    { value: '4:3', label: '4:3(가로로 긴)' },
    { value: '16:9', label: '16:9(가로로 긴)' },
];
const MARKET_CARD_LIST_DEFAULTS = {
    layout: 'horizontal',
    gridColumns: 3,
    scrollRows: 3,
    scrollColumns: 6,
    scrollColumnsMax: 20,
    cardWidth: 120,
    imageRatio: '1:1',
};
function homeCardListSettings(id, name, defaults) {
    const base = { screen: 'home', minBuildNumber: null };
    return [
        {
            ...base,
            key: `home.${id}.layout`,
            label: `${name} 배치`,
            help: '세로 나열 = 화면 폭을 나눠 아래로 이어진다. 가로 스크롤 = 옆으로 넘겨 본다',
            type: 'enum',
            defaultValue: defaults.layout,
            options: [
                { value: 'grid', label: '세로 나열' },
                { value: 'horizontal', label: '가로 스크롤' },
            ],
        },
        {
            ...base,
            key: `home.${id}.gridColumns`,
            label: `${name} 세로 나열: 한 줄 개수`,
            help: '배치가 "세로 나열"일 때 한 줄에 나란히 놓는 카드 수(카드 폭은 화면 폭을 나눈 크기)',
            type: 'integer',
            defaultValue: defaults.gridColumns,
            min: 1,
            max: 4,
            unit: '개',
        },
        {
            ...base,
            key: `home.${id}.scrollRows`,
            label: `${name} 가로 스크롤: 줄 수`,
            help: '배치가 "가로 스크롤"일 때 위아래로 쌓는 줄 수. 보이는 개수는 줄 수 × 한 줄 개수와 "개수" 중 작은 쪽',
            type: 'integer',
            defaultValue: defaults.scrollRows,
            min: 1,
            max: 5,
            unit: '줄',
        },
        {
            ...base,
            key: `home.${id}.scrollColumns`,
            label: `${name} 가로 스크롤: 한 줄 개수`,
            help: '배치가 "가로 스크롤"일 때 한 줄에 놓는 카드 수. 넘치는 카드는 다음 줄로 간다',
            type: 'integer',
            defaultValue: defaults.scrollColumns,
            min: 1,
            max: defaults.scrollColumnsMax,
            unit: '개',
        },
        {
            ...base,
            key: `home.${id}.cardWidth`,
            label: `${name} 가로 스크롤: 카드 폭`,
            help: '배치가 "가로 스크롤"일 때 카드 한 장의 가로 크기. 세로 크기는 이미지 비율을 따른다',
            type: 'integer',
            defaultValue: defaults.cardWidth,
            min: 80,
            max: 320,
            unit: 'px',
        },
        {
            ...base,
            key: `home.${id}.imageRatio`,
            label: `${name} 이미지 비율(가로:세로)`,
            type: 'enum',
            defaultValue: defaults.imageRatio,
            options: CARD_IMAGE_RATIO_OPTIONS,
        },
        imageFit(`home.${id}.imageFit`, `${name} 이미지 맞춤`, 'cover'),
        {
            ...base,
            key: `home.${id}.autoScroll`,
            label: `${name} 가로 스크롤: 자동 넘김`,
            help: '배치가 "가로 스크롤"일 때 정한 간격마다 카드 한 장씩 옆으로 넘어가고 끝에서 처음으로 돌아온다. 손으로 넘기면 잠시 멈춘다',
            type: 'boolean',
            defaultValue: false,
        },
        {
            ...base,
            key: `home.${id}.autoScrollIntervalMs`,
            label: `${name} 가로 스크롤: 자동 넘김 간격`,
            type: 'integer',
            defaultValue: 4000,
            min: 2000,
            max: 15000,
            unit: 'ms',
        },
    ];
}
function collapseEmptyRows(id, name) {
    return {
        key: `home.${id}.collapseEmptyRows`,
        screen: 'home',
        label: `${name} 가로 스크롤: 빈 줄 접기`,
        help: '상품이 적어 비는 줄의 높이를 없앤다. 끄면 기존처럼 상품 수와 관계없이 줄 수만큼 높이를 차지한다',
        type: 'boolean',
        defaultValue: false,
        minBuildNumber: null,
    };
}
export const PROFILE_SETUP_PHONE_REQUIRED_SETTING_KEY = 'common.profileSetup.phoneVerificationRequired';
export const PROFILE_SETUP_INTEREST_CATEGORIES_REQUIRED_SETTING_KEY = 'common.profileSetup.interestCategoriesRequired';
export const THEME_LIGHT_BACKGROUND_SETTING_KEY = 'common.theme.lightBackground';
export const THEME_DARK_BACKGROUND_SETTING_KEY = 'common.theme.darkBackground';
export const THEME_BACKGROUND_MIN_CONTRAST = 7;
export const THEME_BACKGROUND_MIN_SECONDARY_CONTRAST = 4.5;
export const THEME_LIGHT_SUB_BACKGROUND_SETTING_KEY = 'common.theme.lightSubBackground';
export const THEME_DARK_SUB_BACKGROUND_SETTING_KEY = 'common.theme.darkSubBackground';
const THEME_SUB_BACKGROUND_MIN_BUILD = 179215889;
export const PROFILE_SETUP_TITLE_SETTING_KEY = 'common.profileSetup.title';
export const PROFILE_SETUP_SUBTITLE_SETTING_KEY = 'common.profileSetup.subtitle';
export const SALES_TOTAL_HOST_VISIBLE_SETTING_KEY = 'broadcast.salesTotal.hostVisible';
export const BROADCAST_SIDE_MENU_STYLE_SETTING_KEY = 'broadcast.layout.sideMenuStyle';
export const BROADCAST_SIDE_MENU_STYLES = ['grouped', 'separate'];
export const BROADCAST_LISTING_PANEL_STYLE_SETTING_KEY = 'broadcast.layout.listingPanelStyle';
export const BROADCAST_LISTING_PANEL_STYLES = ['panel', 'card'];
export const BROADCAST_SALES_TOTAL_ALIGN_SETTING_KEY = 'broadcast.layout.salesTotalAlign';
export const BROADCAST_SALES_TOTAL_ALIGNS = ['right', 'left'];
export const BROADCAST_ACCENT_COLOR_SETTING_KEY = 'broadcast.layout.accentColor';
export const BROADCAST_ACCENT_LABEL_COLOR = '#18191B';
export const BROADCAST_ACCENT_MIN_CONTRAST = 4.5;
export const BROADCAST_SIDE_MENU_BACKGROUND_COLOR_SETTING_KEY = 'broadcast.layout.sideMenuBackgroundColor';
export const BROADCAST_SIDE_MENU_BACKGROUND_OPACITY_SETTING_KEY = 'broadcast.layout.sideMenuBackgroundOpacity';
export const BROADCAST_LISTING_PANEL_BACKGROUND_COLOR_SETTING_KEY = 'broadcast.layout.listingPanelBackgroundColor';
export const BROADCAST_LISTING_PANEL_BACKGROUND_OPACITY_SETTING_KEY = 'broadcast.layout.listingPanelBackgroundOpacity';
export const APP_UI_SETTING_CATALOG = [
    {
        key: 'common.tabBar.labelVisible',
        screen: 'common',
        group: '하단 탭',
        label: '아이콘 아래 이름 표시',
        help: '하단 탭 아이콘 아래에 이름(홈·마켓·추가·라운지·마이페이지)을 보인다. 이름은 앱관리 > 앱 문구의 navigation.tabs.* 에서, 아이콘은 앱관리 > 아이콘(Home·Market·Make·Feather·My)에서 바꾼다',
        type: 'boolean',
        defaultValue: true,
        minBuildNumber: TAB_BAR_MIN_BUILD,
    },
    {
        key: 'common.liveBadge.color',
        screen: 'common',
        label: 'LIVE 배지 색',
        help: '홈·라이브 더보기의 진행중 방송 카드 LIVE 배지 (broadcast-cards/LiveBadge.tsx)',
        type: 'color',
        defaultValue: '#FF5C16',
        minBuildNumber: null,
    },
    {
        key: THEME_LIGHT_BACKGROUND_SETTING_KEY,
        screen: 'common',
        label: '라이트 모드 배경색',
        help: '라이트 모드의 기본 바탕(화면·카드·시트 바탕). 보조 배경·글자·아이콘은 그대로이고, 라이브 방송 화면은 바뀌지 않는다. 글자색(#18191B)과 대비 7:1·보조 글자색(#65676B)과 4.5:1 이상인 밝은 색만 저장된다. 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'color',
        defaultValue: '#FFFFFF',
        contrast: [
            { with: '#18191B', min: THEME_BACKGROUND_MIN_CONTRAST },
            { with: '#65676B', min: THEME_BACKGROUND_MIN_SECONDARY_CONTRAST },
        ],
        minBuildNumber: null,
    },
    {
        key: THEME_DARK_BACKGROUND_SETTING_KEY,
        screen: 'common',
        label: '다크 모드 배경색',
        help: '다크 모드의 기본 바탕(화면·카드·시트 바탕). 보조 배경·글자·아이콘은 그대로이고, 라이브 방송 화면은 바뀌지 않는다. 글자색(#FFFFFF)과 대비 7:1·보조 글자색(#C8C9D2)과 4.5:1 이상인 어두운 색만 저장된다. 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'color',
        defaultValue: '#1F2023',
        contrast: [
            { with: '#FFFFFF', min: THEME_BACKGROUND_MIN_CONTRAST },
            { with: '#C8C9D2', min: THEME_BACKGROUND_MIN_SECONDARY_CONTRAST },
        ],
        minBuildNumber: null,
    },
    {
        key: THEME_LIGHT_SUB_BACKGROUND_SETTING_KEY,
        screen: 'common',
        label: '라이트 모드 서브 배경색',
        help: '라이트 모드의 보조 바탕(바탕 위 카드·칩·입력칸·안내 상자). 기본값은 디자인 시안의 서브 배경색(#F3F3F3). 라이브 방송 화면은 바뀌지 않는다. 글자색(#18191B)과 대비 7:1·보조 글자색(#65676B)과 4.5:1 이상인 밝은 색만 저장된다. 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'color',
        defaultValue: '#F3F3F3',
        contrast: [
            { with: '#18191B', min: THEME_BACKGROUND_MIN_CONTRAST },
            { with: '#65676B', min: THEME_BACKGROUND_MIN_SECONDARY_CONTRAST },
        ],
        minBuildNumber: THEME_SUB_BACKGROUND_MIN_BUILD,
    },
    {
        key: THEME_DARK_SUB_BACKGROUND_SETTING_KEY,
        screen: 'common',
        label: '다크 모드 서브 배경색',
        help: '다크 모드의 보조 바탕(바탕 위 카드·칩·입력칸·안내 상자). 기본값은 디자인 시안의 서브 배경색(#323337). 라이브 방송 화면은 바뀌지 않는다. 글자색(#FFFFFF)과 대비 7:1·보조 글자색(#C8C9D2)과 4.5:1 이상인 어두운 색만 저장된다. 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'color',
        defaultValue: '#323337',
        contrast: [
            { with: '#FFFFFF', min: THEME_BACKGROUND_MIN_CONTRAST },
            { with: '#C8C9D2', min: THEME_BACKGROUND_MIN_SECONDARY_CONTRAST },
        ],
        minBuildNumber: THEME_SUB_BACKGROUND_MIN_BUILD,
    },
    {
        key: PROFILE_SETUP_PHONE_REQUIRED_SETTING_KEY,
        screen: 'common',
        label: '필수 정보 입력: 휴대폰 번호 인증',
        help: '켜면 휴대폰 번호를 인증하지 않은 회원에게 로그인 뒤 "필수 정보 입력" 화면의 휴대폰 번호 인증 영역이 보이고, 인증 전에는 다른 화면으로 갈 수 없다. 기본은 켜짐(필수) — 문자(SMS) 발송 키가 없는 서버에서는 인증번호가 나가지 않으므로 끈다. 회원 정보를 다시 불러올 때(앱 실행·화면 복귀)부터 적용',
        type: 'boolean',
        defaultValue: true,
        minBuildNumber: null,
    },
    {
        key: PROFILE_SETUP_TITLE_SETTING_KEY,
        screen: 'common',
        label: '필수 정보 입력: 안내 제목',
        help: '"필수 정보 입력" 화면 맨 위 제목. 비워 두면 앱 기본 문구("서비스 이용을 위해 정보를 입력해 주세요", 영어·베트남어는 번역)이고, 입력하면 모든 언어에서 이 문구가 보인다',
        type: 'text',
        defaultValue: '',
        maxLength: 40,
        minBuildNumber: null,
    },
    {
        key: PROFILE_SETUP_SUBTITLE_SETTING_KEY,
        screen: 'common',
        label: '필수 정보 입력: 안내 문구',
        help: '제목 아래 안내 문구. 비워 두면 앱 기본 문구("아래 항목을 모두 마쳐야 볼트비를 이용할 수 있어요.", 영어·베트남어는 번역)이고, 입력하면 모든 언어에서 이 문구가 보인다',
        type: 'text',
        defaultValue: '',
        maxLength: 100,
        minBuildNumber: null,
    },
    {
        key: PROFILE_SETUP_INTEREST_CATEGORIES_REQUIRED_SETTING_KEY,
        screen: 'common',
        label: '필수 정보 입력: 관심 카테고리',
        help: '켜면 관심 카테고리를 하나도 고르지 않은 회원에게 "필수 정보 입력" 화면의 관심 카테고리 영역이 보이고, 1개 이상 고르기 전에는 다른 화면으로 갈 수 없다. 둘 다 끄면 이 화면은 뜨지 않는다',
        type: 'boolean',
        defaultValue: true,
        minBuildNumber: null,
    },
    ...inGroup('화면 공통', [
        {
            key: 'home.section.gap',
            screen: 'home',
            label: '섹션 간격',
            help: '섹션 사이 세로 간격. 기본값 16은 기존 간격(앱·웹 모두 16) 그대로, 다른 값은 그 크기',
            type: 'integer',
            defaultValue: 16,
            min: 0,
            max: 48,
            unit: 'px',
            minBuildNumber: null,
        },
        {
            key: 'home.section.order',
            screen: 'home',
            label: '섹션 순서(이전 방식)',
            help: '영역별 "표시 순서"로 바뀌었다',
            type: 'order',
            defaultValue: HOME_SECTION_ORDER_ITEMS.map((i) => i.value),
            items: HOME_SECTION_ORDER_ITEMS,
            minBuildNumber: null,
            deprecated: true,
        },
    ]),
    ...inGroup('상단 배너', [
        visible('home.banner.visible', 'home', '배너 노출'),
        {
            key: 'home.banner.maxItems',
            screen: 'home',
            label: '배너 최대 개수',
            help: '0 = 제한 없음(등록된 배너 전부). 등록된 배너가 없으면 앱에 들어 있는 기본 배너가 보인다',
            type: 'integer',
            defaultValue: 0,
            min: 0,
            max: 20,
            unit: '개',
            minBuildNumber: null,
        },
        {
            key: 'home.banner.autoPlay',
            screen: 'home',
            label: '배너 자동 넘김',
            type: 'boolean',
            defaultValue: true,
            minBuildNumber: null,
        },
        {
            key: 'home.banner.autoPlayIntervalMs',
            screen: 'home',
            label: '배너 자동 넘김 간격',
            type: 'integer',
            defaultValue: 4000,
            min: 2000,
            max: 15000,
            unit: 'ms',
            minBuildNumber: null,
        },
        {
            key: 'home.banner.aspectRatio',
            screen: 'home',
            label: '배너 비율(가로:세로)',
            help: '이미지가 비율과 다르면 "배너 이미지 맞춤"에 따라 여백이 생기거나 잘린다',
            type: 'enum',
            defaultValue: '16:9',
            options: [
                { value: '16:9', label: '16:9' },
                { value: '2:1', label: '2:1' },
                { value: '3:1', label: '3:1' },
                { value: '4:1', label: '4:1' },
                { value: '4:3', label: '4:3' },
                { value: '1:1', label: '1:1' },
            ],
            minBuildNumber: null,
        },
        imageFit('home.banner.imageFit', '배너 이미지 맞춤', 'contain'),
    ]),
    ...inGroup('카테고리 아이콘', [
        visible('home.categories.visible', 'home', '카테고리 아이콘 노출'),
    ]),
    ...inGroup('진행중 라이브', [
        visible('home.currentLive.visible', 'home', '진행중 라이브 노출'),
        homeSectionOrder('currentLive', '진행중 라이브', 1),
        homeSectionMarginTop('currentLive', '진행중 라이브', 0),
        {
            key: 'home.currentLive.maxItems',
            screen: 'home',
            label: '진행중 라이브 개수',
            help: '기본 배치(세로 나열)에서는 2열로 보인다',
            type: 'integer',
            defaultValue: 4,
            min: 2,
            max: 20,
            unit: '개',
            minBuildNumber: null,
        },
        homeSectionEmptyMode('currentLive', '진행중 라이브', 'compact'),
        ...homeCardListSettings('currentLive', '진행중 라이브', {
            layout: 'grid',
            gridColumns: 2,
            scrollRows: 1,
            scrollColumns: 20,
            scrollColumnsMax: 20,
            cardWidth: 160,
            imageRatio: '3:4',
        }),
    ]),
    ...inGroup('예정 라이브', [
        visible('home.scheduledLive.visible', 'home', '예정 라이브 노출'),
        homeSectionOrder('scheduledLive', '예정 라이브', 2),
        homeSectionMarginTop('scheduledLive', '예정 라이브', 16),
        {
            key: 'home.scheduledLive.maxItems',
            screen: 'home',
            label: '예정 라이브 최대 개수',
            help: '기본 100 = 받아 온 전부',
            type: 'integer',
            defaultValue: 100,
            min: 1,
            max: 100,
            unit: '개',
            minBuildNumber: null,
        },
        homeSectionEmptyMode('scheduledLive', '예정 라이브', 'full', '안내 문구는 앱관리 > 앱 문구의 "broadcast.noScheduledLive"에서 바꾼다'),
        ...homeCardListSettings('scheduledLive', '예정 라이브', {
            layout: 'grid',
            gridColumns: 2,
            scrollRows: 1,
            scrollColumns: 100,
            scrollColumnsMax: 100,
            cardWidth: 160,
            imageRatio: '3:4',
        }),
    ]),
    ...inGroup('볼트비 마켓', [
        visible('home.boltbMarket.visible', 'home', '볼트비 마켓 노출', '앱관리 > BoltB 마켓 섹션 노출 설정(카테고리)과 함께 켜져 있어야 보인다'),
        homeSectionOrder('boltbMarket', '볼트비 마켓', 3),
        homeSectionMarginTop('boltbMarket', '볼트비 마켓', 32),
        {
            key: 'home.boltbMarket.maxItems',
            screen: 'home',
            label: '볼트비 마켓 개수',
            type: 'integer',
            defaultValue: 18,
            min: 1,
            max: 20,
            unit: '개',
            minBuildNumber: null,
        },
        homeSectionEmptyMode('boltbMarket', '볼트비 마켓', 'full'),
        ...homeCardListSettings('boltbMarket', '볼트비 마켓', MARKET_CARD_LIST_DEFAULTS),
        collapseEmptyRows('boltbMarket', '볼트비 마켓'),
    ]),
    ...inGroup('마켓', [
        visible('home.market.visible', 'home', '마켓 노출'),
        homeSectionOrder('market', '마켓', 4),
        homeSectionMarginTop('market', '마켓', 32),
        {
            key: 'home.market.maxItems',
            screen: 'home',
            label: '마켓 개수',
            type: 'integer',
            defaultValue: 18,
            min: 1,
            max: 20,
            unit: '개',
            minBuildNumber: null,
        },
        homeSectionEmptyMode('market', '마켓', 'full'),
        ...homeCardListSettings('market', '마켓', MARKET_CARD_LIST_DEFAULTS),
        collapseEmptyRows('market', '마켓'),
    ]),
    ...inGroup('공지사항', [
        visible('home.notices.visible', 'home', '공지사항 노출', '공지가 없으면 설정과 관계없이 숨는다'),
        homeSectionOrder('notices', '공지사항', 5),
        homeSectionMarginTop('notices', '공지사항', 16),
        {
            key: 'home.notices.maxItems',
            screen: 'home',
            label: '공지사항 개수',
            help: '제목 목록일 때의 줄 수(공지 배너가 있으면 배너가 대신 보인다)',
            type: 'integer',
            defaultValue: 3,
            min: 1,
            max: 3,
            unit: '개',
            minBuildNumber: null,
        },
        {
            key: 'home.noticeBanner.maxItems',
            screen: 'home',
            label: '공지 배너 최대 개수',
            help: '0 = 제한 없음(배너가 있는 공지 전부)',
            type: 'integer',
            defaultValue: 0,
            min: 0,
            max: 20,
            unit: '개',
            minBuildNumber: null,
        },
        {
            key: 'home.noticeBanner.autoPlay',
            screen: 'home',
            label: '공지 배너 자동 넘김',
            help: '배너가 2개 이상일 때만 넘어간다',
            type: 'boolean',
            defaultValue: true,
            minBuildNumber: null,
        },
        {
            key: 'home.noticeBanner.autoPlayIntervalMs',
            screen: 'home',
            label: '공지 배너 자동 넘김 간격',
            type: 'integer',
            defaultValue: 4000,
            min: 2000,
            max: 15000,
            unit: 'ms',
            minBuildNumber: null,
        },
        {
            key: 'home.noticeBanner.aspectRatio',
            screen: 'home',
            label: '공지 배너 비율(가로:세로)',
            help: '관리자 공지 배너 등록 화면의 권장 비율 안내·미리보기가 여기서 선택한 비율을 따른다. 등록한 이미지의 비율이 다르면 "공지 배너 이미지 맞춤"에 따라 잘리거나 여백이 생긴다',
            type: 'enum',
            defaultValue: '188:97',
            options: [
                { value: '188:97', label: '188:97' },
                { value: '16:9', label: '16:9' },
                { value: '2:1', label: '2:1' },
                { value: '3:1', label: '3:1' },
                { value: '4:1', label: '4:1' },
                { value: '4:3', label: '4:3' },
                { value: '1:1', label: '1:1' },
            ],
            minBuildNumber: null,
        },
        imageFit('home.noticeBanner.imageFit', '공지 배너 이미지 맞춤', 'cover'),
    ]),
    ...inGroup('힛 갤러리', [
        {
            ...visible('home.liveSnapshot.visible', 'home', '힛 갤러리 노출', '이름은 라운지 탭의 "힛 갤러리 이름"'),
            minBuildNumber: LIVE_SNAPSHOT_MIN_BUILD,
        },
        homeSectionOrder('liveSnapshot', '힛 갤러리', 6),
        homeSectionMarginTop('liveSnapshot', '힛 갤러리', 16),
        {
            key: 'home.liveSnapshot.maxItems',
            screen: 'home',
            label: '힛 갤러리 개수',
            help: '홈에 보이는 최근 게시물 수',
            type: 'integer',
            defaultValue: 10,
            min: 1,
            max: 20,
            unit: '개',
            minBuildNumber: LIVE_SNAPSHOT_MIN_BUILD,
        },
        homeSectionEmptyMode('liveSnapshot', '힛 갤러리', 'full'),
        ...homeCardListSettings('liveSnapshot', '힛 갤러리', {
            layout: 'horizontal',
            gridColumns: 3,
            scrollRows: 1,
            scrollColumns: 20,
            scrollColumnsMax: 20,
            cardWidth: 132,
            imageRatio: '1:1',
        }),
    ]),
    ...inGroup('라운지 인기글', [
        visible('home.popularLounge.visible', 'home', '라운지 인기글 노출'),
        homeSectionOrder('popularLounge', '라운지 인기글', 7),
        homeSectionMarginTop('popularLounge', '라운지 인기글', 16),
        {
            key: 'home.popularLounge.maxItems',
            screen: 'home',
            label: '라운지 인기글 개수',
            type: 'integer',
            defaultValue: 4,
            min: 1,
            max: 4,
            unit: '개',
            minBuildNumber: null,
        },
        homeSectionEmptyMode('popularLounge', '라운지 인기글', 'full'),
    ]),
    ...inGroup('딜러채팅방', [
        visible('home.dealerChat.visible', 'home', '딜러채팅방 노출', '딜러가 연 채팅방 목록(#144)'),
        homeSectionOrder('dealerChat', '딜러채팅방', 8),
        homeSectionMarginTop('dealerChat', '딜러채팅방', 16),
        {
            key: 'home.dealerChat.maxItems',
            screen: 'home',
            label: '딜러채팅방 최대 개수',
            help: '라운지 탭 딜러채팅방과 같은 순서 — 최근 대화순, 내가 연 방이 맨 앞(서버가 정렬해 내려줌). 관리자 설정 > 딜러채팅방의 정렬은 프로필 화면 목록과 구버전 앱 홈에 쓰인다',
            type: 'integer',
            defaultValue: 10,
            min: 1,
            max: 50,
            unit: '개',
            minBuildNumber: null,
        },
        homeSectionEmptyMode('dealerChat', '딜러채팅방', 'full', '채팅방을 열 수 있는 딜러에게는 이 설정과 관계없이 "딜러채팅방 개설하기" 버튼만 보인다'),
    ]),
    ...inGroup('커뮤니티', [
        visible('home.community.visible', 'home', '커뮤니티 노출'),
        homeSectionOrder('community', '커뮤니티', 9),
        homeSectionMarginTop('community', '커뮤니티', 16),
        {
            key: 'home.community.maxItems',
            screen: 'home',
            label: '커뮤니티 최대 개수',
            help: '0 = 제한 없음(서버가 준 전부)',
            type: 'integer',
            defaultValue: 0,
            min: 0,
            max: 50,
            unit: '개',
            minBuildNumber: null,
        },
        homeSectionEmptyMode('community', '커뮤니티', 'full'),
    ]),
    ...inGroup('하단 사업자 정보', [
        visible('home.companyInfo.visible', 'home', '하단 사업자 정보 노출'),
    ]),
    {
        key: 'market.defaultSort',
        screen: 'market',
        label: '기본 정렬',
        type: 'enum',
        defaultValue: 'newest',
        options: [
            { value: 'newest', label: '최신순' },
            { value: 'oldest', label: '오래된순' },
            { value: 'lowestPrice', label: '낮은 가격순' },
            { value: 'highestPrice', label: '높은 가격순' },
            { value: 'byCategory', label: '카테고리순' },
        ],
        minBuildNumber: null,
    },
    ...loungeHubTabOrderSettings(),
    {
        key: 'lounge.defaultSort',
        screen: 'lounge',
        label: '기본 정렬',
        type: 'enum',
        defaultValue: 'newest',
        options: [
            { value: 'newest', label: '최신순' },
            { value: 'trending', label: '인기순' },
            { value: 'mostViewed', label: '조회순' },
        ],
        minBuildNumber: null,
    },
    {
        key: 'lounge.liveSnapshot.name',
        screen: 'lounge',
        label: '힛 갤러리 이름',
        help: '라운지 탭의 탭 이름·홈 섹션 제목·상세 화면 제목·공유 미리보기에 쓰는 이름. 비워 두면 앱 기본 이름("힛 갤러리", 영어·베트남어는 번역)이고, 입력하면 모든 언어에서 이 이름이 보인다',
        type: 'text',
        defaultValue: '',
        maxLength: 20,
        minBuildNumber: LIVE_SNAPSHOT_MIN_BUILD,
    },
    {
        key: 'chat.defaultFilter',
        screen: 'chat',
        label: '기본 필터',
        type: 'enum',
        defaultValue: 'all',
        options: [
            { value: 'all', label: '전체 채팅' },
            { value: 'direct', label: '1:1' },
            { value: 'community', label: '커뮤니티' },
            { value: 'unread', label: '안읽음' },
        ],
        minBuildNumber: null,
    },
    ...chatFilterTabSettings(),
    {
        key: 'me.initialTab',
        screen: 'me',
        label: '처음 여는 탭',
        type: 'enum',
        defaultValue: 'collector',
        options: [
            { value: 'collector', label: '구매' },
            { value: 'dealer', label: '판매' },
        ],
        minBuildNumber: null,
    },
    visible('me.collector.paymentMethods.visible', 'me', '구매 탭: 결제 수단 관리'),
    visible('me.collector.mainCardSelection.visible', 'me', '구매 탭: 메인 카드 선택'),
    visible('me.collector.shippingAddresses.visible', 'me', '구매 탭: 배송지 관리'),
    visible('me.collector.repaymentPending.visible', 'me', '구매 탭: 재결제 대기중 목록'),
    visible('me.collector.returns.visible', 'me', '구매 탭: 반품/환불 목록'),
    visible('me.collector.interestCategories.visible', 'me', '구매 탭: 관심 카테고리'),
    visible('me.collector.phoneNumber.visible', 'me', '구매 탭: 휴대전화번호 관리'),
    visible('me.collector.inviteFriends.visible', 'me', '구매 탭: 친구 초대하기'),
    visible('me.dealer.repaymentPending.visible', 'me', '판매 탭: 재결제 대기중 목록'),
    visible('me.dealer.interestCategories.visible', 'me', '판매 탭: 관심 카테고리'),
    visible('me.dealer.returnRequests.visible', 'me', '판매 탭: 반품 신청 목록'),
    visible('me.dealer.cancellationRequests.visible', 'me', '판매 탭: 취소 요청 목록'),
    visible('me.dealer.settlementAccount.visible', 'me', '판매 탭: 정산 계좌 관리'),
    visible('me.dealer.settlementHistory.visible', 'me', '판매 탭: 판매 대금 정산 내역'),
    visible('me.dealer.phoneNumber.visible', 'me', '판매 탭: 휴대전화번호 관리'),
    visible('me.dealer.inviteFriends.visible', 'me', '판매 탭: 친구 초대하기'),
    visible('me.dealer.dealerChatRoomCreate.visible', 'me', '판매 탭: 딜러채팅방 개설'),
    visible('me.policyLinks.visible', 'me', '공지·약관·정책 링크 묶음'),
    visible('me.customerService.visible', 'me', '고객센터(이메일·1:1 문의)'),
    {
        key: SALES_TOTAL_HOST_VISIBLE_SETTING_KEY,
        screen: 'broadcast',
        label: '총 매출: 판매자(방송 진행자)에게 표시',
        help: '켜면 방송 진행자의 라이브 방송 화면에 그 방송의 총 매출이 보인다(앱만, 시청자에게는 보이지도 전송되지도 않는다). 금액은 구매 순위와 같은 계산 — 결제 완료 + 결제 대기 주문의 합, 그 방송에서 붙은 배송비 포함, 취소·만료·반품은 빠진다. 결제 대기 금액은 아래 줄에 따로 보인다. 주문이 생기거나 바뀔 때만 갱신된다. 이 기능이 든 앱 빌드부터 적용',
        type: 'boolean',
        defaultValue: false,
        minBuildNumber: null,
    },
    {
        key: BROADCAST_SIDE_MENU_STYLE_SETTING_KEY,
        screen: 'broadcast',
        group: '화면 모양',
        label: '오른쪽 버튼(공유·소리·구매 등) 모양',
        help: '시안: 버튼들을 반투명 띠 하나로 묶고 글자를 작게(11px), 선 아이콘(공유·소리·마이크·전환·확대 — 끈 상태는 기존 꺼짐 아이콘), 소리·마이크 글자는 켜짐/꺼짐, 등록 버튼은 강조색 / 이전: 버튼을 따로 놓고 기존 아이콘·글자(소리·마이크). 보이는 버튼은 같다. 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'enum',
        defaultValue: 'grouped',
        options: [
            { value: 'grouped', label: '시안 — 한 띠로 묶음' },
            { value: 'separate', label: '이전 — 따로 놓음' },
        ],
        minBuildNumber: null,
    },
    {
        key: BROADCAST_LISTING_PANEL_STYLE_SETTING_KEY,
        screen: 'broadcast',
        group: '화면 모양',
        label: '판매 상품 영역 모양',
        help: '시안: 화면 폭 전체의 어두운 패널(위 모서리만 둥글게), 최고입찰자·배송비를 한 줄 칩으로, 상품 사진 48px·이름 한 줄 / 이전: 둥근 카드, 배송비는 상품명 아래. 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'enum',
        defaultValue: 'panel',
        options: [
            { value: 'panel', label: '시안 — 화면 폭 패널' },
            { value: 'card', label: '이전 — 둥근 카드' },
        ],
        minBuildNumber: null,
    },
    {
        key: BROADCAST_SALES_TOTAL_ALIGN_SETTING_KEY,
        screen: 'broadcast',
        group: '화면 모양',
        label: '총 매출 위치(진행자 화면)',
        help: '기본: 맨 위 줄 접속자 수 앞(개발항목 317 — 그 전 앱 빌드는 메모 버튼 줄 오른쪽) / 이전: 구매 순위 위 왼쪽. 총 매출이 보일 때만 해당("총 매출: 판매자에게 표시"). 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'enum',
        defaultValue: 'right',
        options: [
            { value: 'right', label: '기본 — 맨 위 접속자 수 앞' },
            { value: 'left', label: '이전 — 구매 순위 위 왼쪽' },
        ],
        minBuildNumber: null,
    },
    {
        key: BROADCAST_ACCENT_COLOR_SETTING_KEY,
        screen: 'broadcast',
        group: '화면 모양',
        label: '강조색(입찰·구매 버튼, 남은 시간, 최고입찰 표시)',
        help: `시안 #EEFF00 · 이전 모양의 노랑 #FFD700. 버튼 글자(${BROADCAST_ACCENT_LABEL_COLOR})와 대비 ${BROADCAST_ACCENT_MIN_CONTRAST}:1 이상인 밝은 색만 저장된다. 이 기능이 든 앱 빌드·모바일 웹부터 적용`,
        type: 'color',
        defaultValue: '#EEFF00',
        contrast: [{ with: BROADCAST_ACCENT_LABEL_COLOR, min: BROADCAST_ACCENT_MIN_CONTRAST }],
        minBuildNumber: null,
    },
    {
        key: BROADCAST_SIDE_MENU_BACKGROUND_COLOR_SETTING_KEY,
        screen: 'broadcast',
        group: '화면 모양',
        label: '측면 버튼 묶음 바탕색',
        help: '오른쪽 측면 버튼 묶음(측면 버튼 모양 "시안")의 바탕색. 아래 불투명도와 함께 쓴다. 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'color',
        defaultValue: '#000000',
        minBuildNumber: null,
    },
    {
        key: BROADCAST_SIDE_MENU_BACKGROUND_OPACITY_SETTING_KEY,
        screen: 'broadcast',
        group: '화면 모양',
        label: '측면 버튼 묶음 바탕 불투명도',
        help: '0이면 바탕 없이 버튼만(기본), 100이면 바탕색 그대로. 시안은 50. 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'integer',
        defaultValue: 0,
        min: 0,
        max: 100,
        unit: '%',
        minBuildNumber: null,
    },
    {
        key: BROADCAST_LISTING_PANEL_BACKGROUND_COLOR_SETTING_KEY,
        screen: 'broadcast',
        group: '화면 모양',
        label: '입찰 영역(상품 패널) 바탕색',
        help: '화면 아래 입찰·구매 영역(상품 패널 모양 "시안")의 바탕색. 아래 불투명도와 함께 쓴다. 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'color',
        defaultValue: '#000000',
        minBuildNumber: null,
    },
    {
        key: BROADCAST_LISTING_PANEL_BACKGROUND_OPACITY_SETTING_KEY,
        screen: 'broadcast',
        group: '화면 모양',
        label: '입찰 영역(상품 패널) 바탕 불투명도',
        help: '0이면 바탕 없음, 100이면 바탕색 그대로. 시안·기본은 70. 이 기능이 든 앱 빌드·모바일 웹부터 적용',
        type: 'integer',
        defaultValue: 70,
        min: 0,
        max: 100,
        unit: '%',
        minBuildNumber: null,
    },
];
const RETIRED_APP_UI_SETTINGS = [
    ...tabBarIconSettings(),
    {
        key: 'broadcast.topPurchasers.hostVisible',
        screen: 'broadcast',
        label: '구매 순위: 판매자(방송 진행자)에게 표시',
        type: 'boolean',
        defaultValue: false,
        minBuildNumber: null,
    },
    {
        key: 'broadcast.topPurchasers.viewerVisible',
        screen: 'broadcast',
        label: '구매 순위: 시청자(구매자)에게 표시',
        type: 'boolean',
        defaultValue: false,
        minBuildNumber: null,
    },
    {
        key: 'broadcast.topPurchasers.maxItems',
        screen: 'broadcast',
        label: '구매 순위: 표시 인원',
        type: 'integer',
        defaultValue: 100,
        min: 0,
        max: 9999,
        unit: '명',
        minBuildNumber: null,
    },
];
const RETIRED_BY_KEY = new Map(RETIRED_APP_UI_SETTINGS.map((d) => [d.key, d]));
export function findRetiredAppUiSettingDefinition(key) {
    return RETIRED_BY_KEY.get(key);
}
const CATALOG_BY_KEY = new Map(APP_UI_SETTING_CATALOG.map((d) => [d.key, d]));
export function findAppUiSettingDefinition(key) {
    return CATALOG_BY_KEY.get(key);
}
export function getAppUiSettingDefaults() {
    const defaults = {};
    for (const definition of APP_UI_SETTING_CATALOG) {
        defaults[definition.key] = Array.isArray(definition.defaultValue)
            ? [...definition.defaultValue]
            : definition.defaultValue;
    }
    return defaults;
}
export const APP_UI_SETTING_SCREEN_LABELS = {
    common: '공통',
    home: '홈',
    market: '마켓 탭',
    lounge: '라운지 탭',
    chat: '채팅 목록',
    me: '마이페이지',
    broadcast: '라이브 방송',
};
//# sourceMappingURL=catalog.js.map